import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  DialogActions,
  IconButton,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { SecondaryButton } from "../../../ui/SecondaryButton";
import { PrimaryButton } from "../../../ui/PrimaryButton";
const EditScriptModal = ({
  onClose,
  onSubmitEdit,
  onDeleteScriptText,
  modalData,
}) => {
  // const [comment, setComment] = useState(initialComment);
  // const [category, setCategory] = useState(initialCategory);
  const [category, setCategory] = useState(modalData.category);
  const [scripts, setScripts] = useState([...modalData.scripts]);
  const handleSubmit = () => {
    onSubmitEdit({
      id: modalData.id,
      title: category,
      scripts: scripts,
    });
    onClose();
  };

  console.log(modalData);
  useEffect(() => {
    if (modalData) {
      setCategory(modalData.category || "");
      setScripts(modalData.scripts || []);
    }
  }, [modalData]);
  return (
    <>
      <Typography variant="h6" sx={{ pb: 1 }}>
        Редагування скрипту
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        <Typography>Назва категорії</Typography>
        <TextField
          fullWidth
          size="small"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
        {modalData.scripts.map((item, index) => (
          <Box
            key={index} // вместо item
            sx={{ display: "flex", gap: 1, flexDirection: "column" }}
          >
            <Typography>Текст скрипту</Typography>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <TextField
                multiline
                rows={4}
                fullWidth
                value={scripts[index]}
                onChange={(e) => {
                  const newScripts = [...scripts];
                  newScripts[index] = e.target.value;
                  setScripts(newScripts);
                }}
              />
              {/* <IconButton
                onClick={() =>
                  setScripts(scripts.filter((_, i) => i !== index))
                }
              >
                <DeleteOutlineIcon />
              </IconButton> */}
            </Box>
          </Box>
        ))}
      </Box>
      <DialogActions sx={{ p: 0, justifyContent: "start" }}>
        <PrimaryButton onClick={handleSubmit}>Редагувати</PrimaryButton>
        <SecondaryButton onClick={onClose}>Закрити</SecondaryButton>
      </DialogActions>
    </>
  );
};

export default EditScriptModal;
